import { render, staticRenderFns } from "./booking-renew-modal.vue?vue&type=template&id=6c3f122d&"
import script from "./booking-renew-modal.vue?vue&type=script&lang=ts&"
export * from "./booking-renew-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports